import { GridCell } from '@almbrand/grid';
import { Component } from 'components/Component';

export const GridCellComponent: React.FC<{ component: ContentApiModel; className: string }> = ({
	component,
	className,
}) => {
	const { gridSize, tabletGridSize, mobileGridSize, gridMove, mobileGridMove, tabletGridMove } =
		component?.grid ?? {};

	const getGridSize = (size?: GridCellWidth | 'None', defaultSize?: GridCellWidth) => {
		return !size || size === 'None' ? defaultSize : size;
	};

	const getOffset = (offset?: GridCellWidth | 'None') => {
		return !offset || offset === 'None' ? gridMove : offset;
	};

	return (
		<GridCell
			desktopWidth={gridSize}
			tabletWidth={getGridSize(tabletGridSize, gridSize)}
			mobileWidth={getGridSize(mobileGridSize, '12col')}
			desktopOffset={gridMove}
			tabletOffset={getOffset(tabletGridMove)}
			mobileOffset={mobileGridMove}
			className={className}
		>
			<Component {...component?.content} />
		</GridCell>
	);
};
